import {
    STEAM_UPDATE,
    steamChanged,
    steamTicketChanged,
    steamSetHasLoggedIn,
    setUsedTicket,
    getSteamInfo,
    steamAttemptingLogin,
} from '../data'
import { actions, constants, selectors, getAttributes } from '../imports'
import { loginWithSteamTicket } from '../components/TicketExchange'

/* eslint-disable */
function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
    )
}
/* eslint-enable */

const steamLoginData = (state) => {
    const server = selectors.getActiveServer(state)
    const locale = selectors.getLocale(state)
    const attributes = getAttributes(locale)

    if (server == null || server.sso == null) return

    return attributes.ssoUrlFormat
        .replace(/{host}/gi, server.sso.url)
        .replace('{state}', uuidv4())
        .replace(/{locale}/gi, locale)
}

const SteamMiddleware = store => next => (action) => {
    switch (action.type) {
        case STEAM_UPDATE: {
            // first get current steam startup value
            const wasSteam = getSteamInfo(store.getState())
            const result = next(action)
            const isSteam = getSteamInfo(store.getState())

            if (wasSteam.steamStartup !== isSteam.steamStartup) {
                store.dispatch(steamChanged(isSteam.steamStartup))
            }
            if (wasSteam.usedTicket !== isSteam.usedTicket) {
                store.dispatch(steamTicketChanged(isSteam.usedTicket))
            }

            return result
        }

        case constants.ACTIVE_SERVER_CHANGED: {
            const state = store.getState()
            const steamStatus = getSteamInfo(state)

            if (steamStatus.attemptingToLogin || !steamStatus.steamStartup) {
                return next(action)
            }

            // Start by declaring we're attempting a login
            // this is in place to prevent multiple startups at once
            store.dispatch(steamAttemptingLogin(true))

            // Get the login URL
            const loginUrl = steamLoginData(state)

            loginWithSteamTicket(steamStatus.ticket, loginUrl)
                .then(() => {
                    store.dispatch(steamSetHasLoggedIn(true))
                    store.dispatch(setUsedTicket(steamStatus.ticket))
                    store.dispatch(steamAttemptingLogin(false))
                })
                .catch((e) => {
                    if (e.message === 'Network Error') {
                        console.info(
                            `Error during Steam login: ${
                                e.message
                            }. This can indicate an expired steam ticket, no account associated with it on the server, or network errors.`,
                        )
                    } else {
                        console.info(e)

                        // TODO: baldvinth 2018-08-16 change message to be Steam specific
                        const title = selectors.getErrorText(state)
                        const content = selectors.getErrorLoginUserText(state)

                        if (title !== '' && content !== '') {
                            store.dispatch(
                                actions.showError({
                                    title: selectors.getErrorText(state),
                                    content: selectors.getErrorLoginUserText(state),
                                    timeout: 5,
                                }),
                            )
                        }
                    }
                    store.dispatch(steamAttemptingLogin(false))
                })

            return next(action)
        }

        default:
            return next(action)
    }
}

export default SteamMiddleware



// WEBPACK FOOTER //
// ./src/features/Steam/middleware/index.js